import React from 'react';
import { isDevelopment } from '@lp-root/src/utils/environment';
import { graphql, useStaticQuery } from 'gatsby';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import { Body } from '@web/atomic/legacy/atm.typography';
import { useTranslation } from 'gatsby-plugin-react-i18next';

export interface HealthCarerTelehealthInfo {
  description: JSX.Element;
  healthCarerId: string;
  professionId: string;
  imgSrc?: IGatsbyImageData;
  name: string;
  tags: string[];
}

export const useHealthCarersTelehealth = (): HealthCarerTelehealthInfo[] => {
  const { t } = useTranslation('teleconsulta');
  const data = useStaticQuery(graphql`
    query HealthCarersTelehealthQuery {
      caroline: file(relativePath: { eq: "psico-caroline.png" }) {
        childImageSharp {
          gatsbyImageData(width: 136, layout: FIXED, placeholder: BLURRED)
        }
      }
      talita: file(relativePath: { eq: "talita-lobo.png" }) {
        childImageSharp {
          gatsbyImageData(width: 136, layout: FIXED, placeholder: BLURRED)
        }
      }
      juliane: file(relativePath: { eq: "psico-juliane.png" }) {
        childImageSharp {
          gatsbyImageData(width: 136, layout: FIXED, placeholder: BLURRED)
        }
      }
      laura: file(relativePath: { eq: "laura2.png" }) {
        childImageSharp {
          gatsbyImageData(width: 136, layout: FIXED, placeholder: BLURRED)
        }
      }
      vanisse: file(relativePath: { eq: "psico-vanisse.png" }) {
        childImageSharp {
          gatsbyImageData(width: 136, layout: FIXED, placeholder: BLURRED)
        }
      }
    }
  `);
  // # INSTRUCTIONS
  // if you want to show more health-carers, add them to this array
  const hcp: HealthCarerTelehealthInfo[] = [
    {
      name: 'Caroline Rodrigues ',
      imgSrc: data.caroline.childImageSharp.gatsbyImageData,
      healthCarerId: getHcpIdForEnv('1FBp6YeY29chA9pirwULsfWLmyX2'),
      professionId: 'CRP 05/55543',
      tags: t('hcp_caroline_tags', { returnObjects: true }) as string[],
      description: <Body center>{t('hcp_caroline_description')}</Body>,
    },
    {
      name: 'Juliane Santos ',
      imgSrc: data.juliane.childImageSharp.gatsbyImageData,
      healthCarerId: getHcpIdForEnv('xnkN2JZePmfA77trCjO2gdo8F082'),
      professionId: 'CRP 05/55694',
      tags: t('hcp_juliane_tags', { returnObjects: true }) as string[],
      description: (
        <>
          <Body center>{t('hcp_juliane_description')}</Body>
        </>
      ),
    },
    {
      name: 'Laura Castro',
      imgSrc: data.laura.childImageSharp.gatsbyImageData,
      healthCarerId: getHcpIdForEnv('6xLs8W1Zvue9UHGHng46T1ZpDt62'),
      professionId: 'CRP 06/83226',
      tags: t('hcp_laura_tags', { returnObjects: true }) as string[],
      description: (
        <>
          <Body center>{t('hcp_laura_description')}</Body>
        </>
      ),
    },
    {
      name: 'Talita Cepas Lobo',
      imgSrc: data.talita.childImageSharp.gatsbyImageData,
      healthCarerId: getHcpIdForEnv('QwcNKGJfQxg9J6SPL8eHDqm0Ih13'),
      professionId: 'CRP 06/123237',
      tags: t('hcp_talita_tags', { returnObjects: true }) as string[],
      description: (
        <>
          <Body center>{t('hcp_talita_description')}</Body>
        </>
      ),
    },
    {
      name: 'Vanisse Barros',
      imgSrc: data.vanisse.childImageSharp.gatsbyImageData,
      healthCarerId: getHcpIdForEnv('g5BunaOWasguUinhS1nwqKRlyiQ2'),
      professionId: 'CRP 05/53741',
      tags: t('hcp_vanisse_tags', { returnObjects: true }) as string[],
      description: (
        <>
          <Body center>{t('hcp_vanisse_description')}</Body>
        </>
      ),
    },
  ];

  return hcp;
};

const getHcpIdForEnv = (hcpId: string) => (isDevelopment ? 'Y4nwCSH5vnRtivma9A0AAc9SJS13' : hcpId);
